import { render } from "./CommentApproval.vue?vue&type=template&id=1cecc5e9&scoped=true"
import script from "./CommentApproval.vue?vue&type=script&lang=js"
export * from "./CommentApproval.vue?vue&type=script&lang=js"

import "./CommentApproval.vue?vue&type=style&index=0&id=1cecc5e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cecc5e9"]])

export default __exports__